export enum PaymentClientId {
  Cash = 0,
  Tap = 1,
  Migs = 2,
  Knet = 3,
}
